import type { TopDonorWidgetSettings } from './topDonorWidgetSettingsSchema'
import type { Maybe } from '@/types'

export default function getDefaultValues(input?: Maybe<Partial<TopDonorWidgetSettings>>): TopDonorWidgetSettings {
  return {
    darkMode: input?.darkMode ?? true,
    displayNumber: input?.displayNumber ?? 1,
    displayMode: input?.displayMode ?? 'list',
    displayAlignment: input?.displayAlignment ?? 'left',
    headlineText: input?.headlineText ?? 'Top Spender*in',
    headlineFont: input?.headlineFont ?? 'Fira Sans',
    headlineFontWeight: input?.headlineFontWeight ?? 700,
    headlineFontSize: input?.headlineFontSize ?? 32,
    headlineFontColor: input?.headlineFontColor ?? 'ffffff',
    screenNameFont: input?.screenNameFont ?? 'Fira Sans',
    screenNameFontWeight: input?.screenNameFontWeight ?? 700,
    screenNameFontSize: input?.screenNameFontSize ?? 24,
    screenNameFontColor: input?.screenNameFontColor ?? 'ffffff',
    dataFont: input?.dataFont ?? 'Fira Sans',
    dataFontWeight: input?.dataFontWeight ?? 700,
    dataFontSize: input?.dataFontSize ?? 24,
    dataFontColor: input?.dataFontColor ?? '9ECB0A',
  }
}
